import React from 'react';
import { CalendarDaysIcon, ClipboardListIcon, ShieldIcon, UsersIcon, CheckIcon } from 'lucide-react';
const stats = [[CalendarDaysIcon, '365', 'Days of curriculum'], [ClipboardListIcon, '6', 'Coaching modules'], [UsersIcon, 'All', 'Age groups'], [ShieldIcon, 'Full', 'Game coverage']];
const tags = ['Attack', 'Defense', 'Set Pieces', 'Scrum / Lineout', 'Tactical Kicking', 'Physical Preparation', 'Leadership', 'Match Day'];
export function SystemSection() {
  return <section className="border-y-4 border-[#d4af37] bg-[#16161F] px-5 py-20" data-id="element-203">
      <div className="mx-auto max-w-6xl text-center" data-id="element-204">
        <p className="inline-block bg-[#d4af37] px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#0A0A0A]" data-id="element-205">
          The complete system to stop improvising training
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-206">
          Rugby <span className="text-[#d4af37]" data-id="element-207">Ready</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-[#B0B0C0]" data-id="element-208">
          365 days of structured sessions. Attack, defense, set pieces, tactical
          kicking, physical preparation and team leadership.{' '}
          <strong className="text-white" data-id="element-209">Everything ready.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-210">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-[#d4af37]/25 bg-[#0A0A0A] p-6" data-id="element-211">
              <Icon className="mx-auto h-7 w-7 text-[#d4af37]" data-id="element-212" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-213">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-214">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-[#d4af37]/25 bg-[#0A0A0A] p-7" data-id="element-215">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-216">
            Full coverage, every category
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-217">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-[#d4af37]/25 bg-[#16161F] px-3 py-2 text-xs font-bold text-white" data-id="element-218">
                <CheckIcon className="h-3.5 w-3.5 text-[#d4af37]" data-id="element-219" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}